module.exports = __webpack_public_path__ + "img/portrait-083.55b202a4.jpg";